import { InjectionToken } from '@angular/core';
import { GdlAppsOptions } from './models/gdl-app-options';

export const GDL_APPS_OPTIONS = new InjectionToken<GdlAppsOptions>(
  'gdl.app.options'
);
